import {useAddWithPDF} from 'components/hooks/useAdd';
import {content} from 'constants/url';
import {AddingOptions} from '../../../components/grid-dx/types';

function useAddContent() {
  const addContent = useAddWithPDF(content);
  return (addingOptions: AddingOptions) => addContent(addingOptions);
}

export default useAddContent;
